export const ANALOG_PRICE = 500
export const CURRENT_VINTAGE_CREATED_AFTER = '2024-01-01T00:00:00.000Z'
